var _rect, _text, _path, _path2, _rect2, _circle, _text2, _text3, _text4, _text5, _rect3, _circle2, _text6, _text7, _text8, _text9, _rect4, _circle3, _text0, _text1, _text10, _text11, _rect5, _circle4, _text12, _text13, _text14, _text15, _rect6, _circle5, _text16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentDiscoveryMappingWorkspaceDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 430,
    viewBox: "0 0 720 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Discovery and process mapping workflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 428,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 42,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "DISCOVERY WORKSPACE"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 188H620",
    stroke: "#9ABEDC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M615 182l10 6-10 6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 82,
    width: 154,
    height: 164,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 109,
    r: 13,
    fill: "#087CFF",
    fillOpacity: 0.13,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 59,
    y: 113,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 113,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Observe")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 143,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Work in context")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 196,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    dy: 0
  }, "People"), /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    dy: 18
  }, "Tools"), /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    dy: 18
  }, "Constraints"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 82,
    width: 154,
    height: 164,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 109,
    r: 13,
    fill: "#FF2775",
    fillOpacity: 0.13,
    stroke: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 113,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "02")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 113,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Map")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 143,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Flow and handovers")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 196,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    dy: 0
  }, "Data"), /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    dy: 18
  }, "Decisions"), /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    dy: 18
  }, "Ownership"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 82,
    width: 154,
    height: 164,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 109,
    r: 13,
    fill: "#30D6A1",
    fillOpacity: 0.13,
    stroke: "#30D6A1"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 395,
    y: 113,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "03")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 113,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Measure")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 143,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Friction and value")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 386,
    y: 196,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    dy: 0
  }, "Delay"), /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    dy: 18
  }, "Effort"), /*#__PURE__*/React.createElement("tspan", {
    x: 386,
    dy: 18
  }, "Risk"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 82,
    width: 154,
    height: 164,
    rx: 17,
    fill: "#FFFFFF",
    fillOpacity: 0.92,
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 109,
    r: 13,
    fill: "#F4B63D",
    fillOpacity: 0.13,
    stroke: "#F4B63D"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 563,
    y: 113,
    textAnchor: "middle",
    fill: "#F4B63D",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850
  }, "04")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 586,
    y: 113,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 820
  }, "Define")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 554,
    y: 143,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "System opportunity")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 554,
    y: 196,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    dy: 0
  }, "Scope"), /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    dy: 18
  }, "Controls"), /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    dy: 18
  }, "Outcome"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 288,
    width: 658,
    height: 94,
    rx: 17,
    fill: "#07152A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 335,
    r: 7,
    fill: "#30D6A1"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 324,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 86,
    dy: 0
  }, "EVIDENCE-BASED SYSTEM BRIEF"), /*#__PURE__*/React.createElement("tspan", {
    x: 86,
    dy: 23
  }, "A shared view of the problem, the opportunity and the right first build."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentDiscoveryMappingWorkspaceDesktop);
export default __webpack_public_path__ + "static/media/custom-development-discovery-mapping-workspace-desktop.b4736427be8c97b8802faa052aac9a2c.svg";
export { ForwardRef as ReactComponent };